const compute = ({ atom, selector }) => {
    const get = async () => {
        const values = await atom.get();
        return selector(values);
    };
    const set = async () => {
        throw new Error('selected atom does not support set');
    };
    const observe = (callback) => {
        let prev;
        let called;
        return atom.observe(async (values) => {
            const selected = await selector(values);
            if (called && prev === selected)
                return;
            called = true;
            prev = selected;
            return callback(selected);
        });
    };
    const computed = {
        ...atom,
        get,
        set,
        observe,
    };
    return computed;
};
export default compute;
